
// ⚠️ Is file me sirf yahi constants honi chahiye — koi aur import NAHI
// (na axios, na kisi component ka, na Redux store ka), warna circular
// dependency wapas aa jayegi.

// URL env ke hisab se automatic aata hai — dev/uat/live, kahin bhi is file
// me manually comment/uncomment karne ki zarurat nahi. Local (npm start) ke
// liye values .env.development se aati hain; UAT/Live build (npm run build)
// ke liye values us CodeBuild project ke environment variables se aani chahiye.
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const ImagebaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

// Secure channel (Utility/secureChannel.js) default ON hai. Debugging ke liye sirf
// local .env me REACT_APP_SECURE_CHANNEL=off rakh sakte ho — production me kabhi nahi.
export const REACT_APP_SECURE_CHANNEL = process.env.REACT_APP_SECURE_CHANNEL !== "off";

// Sirf URL id tokens (cryptoUtil.encryptId/decryptId) ke liye bacha hai — API
// payload encryption ab secure channel karta hai, is static key se nahi.
// Real values supplied via .env.development.local (gitignored) or the CI/CD secret store — never commit real values here.
export const REACT_ENC_KEY = process.env.REACT_APP_ENC_KEY;


